<template>
    <div class="modal fade" id="settingsModel" tabindex="-1" role="dialog" aria-labelledby="settingsModelTitle" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="settingsModelTitle">Settings</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="form-group">
                            <label for="layerOpacity" style="display: block">Layer opacity: <span style="float: right">{{ layerOpacity }}%</span> </label>
                            <!--<input class="form-control" type="text" id="layerOpacityTextbox" v-model="layerOpacity" />-->
                            <input type="range" class="form-control" min="0" max="100" id="layerOpacity" v-model="layerOpacity" />
                        </div>
                        <div class="form-group">
                            <input type="checkbox" id="dualPaneToggle" v-model="dualPane"> &nbsp;<label for="dualPaneToggle">Display dual map panes</label>
                        </div>
                        <div class="form-group">
                            <input type="checkbox" id="showFullHistoricalToggle" v-model="showFullHistorical">&nbsp;<label for="showFullHistoricalToggle">Show full historical values in map popup</label>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="okClicked">OK</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-secondary" @click="applyClicked">Apply</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import $ from '@/lib/JQuery.js'

export default {
    name: 'SettingsDialog',
    data() {
        return {
            layerOpacity: 0,
            dualPane: false,
            showFullHistorical: false
        }
    },
    methods: {
        okClicked() {
            this.saveSettings()            
            $(this.$refs.modal).modal('hide')
        },
        applyClicked() {
            this.saveSettings()
        },
        saveSettings() {
            this.$store.commit('setLayerOpacity', (this.layerOpacity / 100))
            this.$store.commit('setDualPane', this.dualPane)
            this.$store.commit('setShowFullHistoricalInPopup', this.showFullHistorical)
        },
        updateDialog() {
            this.layerOpacity = (Number(this.$store.state.appSettings.layerOpacity) * 100)
            this.dualPane = Boolean(this.$store.state.appSettings.dualPane)
            this.showFullHistorical = Boolean(this.$store.state.appSettings.showFullHistoricalInPopup)
        },
        show() {
            this.updateDialog()
            $(this.$refs.modal).modal('show')
        }
    }
}
</script>

<style>

</style>
